import {IListView} from './list-view-types';
import React from 'react';

export const ListViewInstanceContext = React.createContext<IListView | null>(null);
